import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";
import { api1 } from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import { API_ENDPOINTS } from "../../../services/apiEndpoints";

const OTPVerificationForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState(Array(6).fill("")); // Initialize OTP array
  const [seconds, setSeconds] = useState(60);
  const [isDisabled, setIsDisabled] = useState(true);
  const [user, setUser] = useState(null);
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setIsDisabled(false);
    }
  }, [seconds]);

  useEffect(() => {
    const fetchUser = async () => {
      if (!sessionId) return;

      try {
        const res = await api1.get(
          `${API_ENDPOINTS.GET_PENDING_USER}?session_id=${sessionId}`
        );
        setUser(res.data);
      } catch (err) {
        console.error("Failed to fetch user from session:", err);
      }
    };

    fetchUser();
  }, [sessionId]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 1) return; // Only allow single character input

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus next input if value is entered
    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  // Handle pasting OTP into all fields at once
  const handlePaste = (e) => {
    const pastedValue = e.clipboardData.getData("Text");
    if (/^\d{6}$/.test(pastedValue)) {
      setOtp(pastedValue.split("")); // Split pasted OTP into an array
    }
  };

  const handleClick = () => {
    // const [searchParams] = useSearchParams();
    // const location = useLocation();
    // const navigate = useNavigate();

    const isPreviousPathResendOtp = location.state?.from === "/auth/resend-otp";
    const isPreviousPathSignUp = location.state?.from === "/auth/signup";
    const cameFromStripe = !!sessionId; // new condition

    if (isPreviousPathSignUp || cameFromStripe) {
      handleVerification();
    } else if (isPreviousPathResendOtp) {
      navigate("/auth/login");
    } else {
      navigate("/auth/newpassword");
    }
  };

  const handleVerification = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      const enteredOtp = otp.join(""); // Convert OTP array to a string

      // Send the email and OTP for verification
      await api1.post("api/auth/verifyotp", {
        email: user ? user.email : userEmail,
        otp: enteredOtp,
      });

      // Check if the previous route was auth/forget
      if (location.state?.fromForgetPassword) {
        navigate("/auth/newpassword");
      } else {
        navigate("/auth/login");
      }
    } catch (error) {
      console.error("Error during verification: ", error);
      toast.error("OTP verification failed. Please try again.");
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center p-8 bg-white">
      <img
        src={logo}
        alt="Logo"
        className="absolute top-4 left-4 w-28 h-auto cursor-pointer"
        onClick={() => navigate("/")}
      />
      <h1 className="text-3xl font-bold text-purple-800 mb-4">
        OTP Verification
      </h1>
      <p className="text-gray-500 mb-2">
        Check your email address and Verify Your OTP to Proceed.
      </p>
      <p className="text-gray-500 mb-6">Just One Step Away!</p>

      <div className="flex space-x-2 mb-6">
        {otp.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onPaste={handlePaste} // Enable pasting OTP into all fields
            maxLength={1}
            className="w-12 h-12 text-center text-xl border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        ))}
      </div>
      <button
        onClick={handleClick}
        className="w-[70%]  py-3 text-white bg-gradient-to-r from-pink-500 to-blue-700 rounded-lg shadow-md hover:opacity-90 transition-all"
      >
        Verify OTP
      </button>

      <p className="text-sm text-gray-500 mt-4">
        {isDisabled ? (
          <>
            You can resend the code in{" "}
            <span className="text-black !text-sm">{seconds} seconds</span>
          </>
        ) : (
          <span
            className="text-purple-600 cursor-pointer hover:underline"
            onClick={() => {
              setSeconds(60);
              setIsDisabled(true);
              navigate("/auth/resend-otp");
            }}
          >
            Resend OTP
          </span>
        )}
      </p>
    </div>
  );
};

export default OTPVerificationForm;
